import { render } from "./ContentDatamanagement.vue?vue&type=template&id=81b6f962&scoped=true&ts=true"
import script from "./ContentDatamanagement.vue?vue&type=script&lang=ts"
export * from "./ContentDatamanagement.vue?vue&type=script&lang=ts"

import "./ContentDatamanagement.vue?vue&type=style&index=0&id=81b6f962&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81b6f962"]])

export default __exports__